import { IsArray, IsNumber, IsOptional, IsString } from "class-validator";

export class FamilyStepOptionDto {
  @IsArray()
  @IsString({ each: true })
  devices!: string[];

  @IsString()
  groupName!: string;

  @IsNumber()
  quantityMin!: number;

  @IsNumber()
  quantityMax!: number;

  @IsString()
  @IsOptional()
  filter1?: string;

  @IsString()
  @IsOptional()
  filter2?: string;

  @IsString()
  @IsOptional()
  subType?: string;

  @IsString()
  @IsOptional()
  groupImageCantoID?: string;

  @IsString()
  @IsOptional()
  description?: string;

  @IsString()
  @IsOptional()
  piSheetURL?: string;

  @IsString()
  @IsOptional()
  configurationURL?: string;
}
